import { Entry } from '../Entry'

export function Entry20230524() {
  return (
    <Entry title="May 24 2023 - v3.4.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13707/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
